<h1>Gestión de apoderados</h1>
<mat-tab-group>
    <mat-tab label="Reuniones">
        <app-meeting [course]="this.course"></app-meeting>
    </mat-tab>
    <mat-tab label="Citaciones" [disabled]="true">
        Citaciones a apoderados
    </mat-tab>
</mat-tab-group>